import { Button, Card, Container, FormLabel, Stack, } from "react-bootstrap";
import Header from "../../../shared/components/Header";
import Layout from "../../../shared/components/Layout";
import DefaultInvoice from "./DefaultInvoice";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectOrderById } from "../../store/ordersSlice";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useEffect, useRef, useState } from "react";
import MobileInvoice from "./MobileInvoice";
import { UilImport } from '@iconscout/react-unicons'

const InvoiceLayout = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const componentRef = useRef();
  const invoiceData = useSelector((state) => selectOrderById(state, id));
  const user = useSelector((state) => state?.auth?.user)
  console.log("invoice data", invoiceData);

  const fetchRazorpayKey = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}tenants/razorpay-key`);
      const data = await response.json();
      return data.razorpay_key;
    } catch (error) {
      console.error('Error fetching Razorpay key:', error);
      return null;
    }
  };


  const handlePayment = async (row) => {
    const orderId = invoiceData.id;
    const planId = invoiceData.selected_plan?.id;
    const planPeriod = invoiceData.selected_plan?.period;

    if (!planId) {
      console.error("Plan ID is missing for the selected order.");
      return;
    }
    //const subscriptionId = await createSubscription(planId);
    //if (!subscriptionId) return;

    const RAZORPAY_KEY = await fetchRazorpayKey();
    if (!RAZORPAY_KEY) {
      console.error("Failed to fetch Razorpay key");
      return;
    }
    const amountInPaise = parseInt(invoiceData.grand_total * 100);


    const options = {
      key: RAZORPAY_KEY,
      currency: "INR",
      amount: amountInPaise,
      name: user.name,
      description: "Test Transaction",
      handler: async function (response) {

        try {
          const verifyResponse = await fetch(
            `${process.env.REACT_APP_API_URL}tenants/verification`,
            {
              method: "POST",
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "X-Tenant": user?.currentTenant,
              },
              body: JSON.stringify({
                razorpay_payment_id: response.razorpay_payment_id,
                orderCreationId: orderId,
                tenantId: user?.currentTenant,
                period: planPeriod,
                amount: invoiceData?.grand_total,
              }),
            }
          );

          const data = await verifyResponse.json();


          if (response.razorpay_payment_id) {
            alert("Payment processed successfully");
            navigate("/billing");
            //window.location.reload();
          } else {
            alert("Payment process failed");
            //window.location.reload();
            navigate("/billing");
          }
        } catch (error) {
          console.error("Error:", error);
          alert("Payment process failed");
        }
      },
      prefill: {
        name: user.name,
        email: user.email,
        contact: user.contact,
      },
      notes: {
        address: "Corporate Office",
        plan_id: planId,
      },
      theme: {
        color: "#F37254",
      },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open(); // Directly open the Razorpay payment page
  };



  const handlePrint = () => {
    const padding = 6;
    const imgWidth = 210 - 2 * padding;
    const pageHeight = 297 - 2 * padding;

    html2canvas(componentRef.current, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      logging: true,
    }).then((canvas) => {
      const pdf = new jsPDF("p", "mm", "a4", true);
      let position = 0;

      while (position < canvas.height) {
        const remainingHeight = canvas.height - position;
        const pageContentHeight = Math.min(
          remainingHeight,
          canvas.width * (pageHeight / imgWidth)
        );

        const pageCanvas = document.createElement("canvas");
        pageCanvas.width = canvas.width;
        pageCanvas.height = pageContentHeight;

        const ctx = pageCanvas.getContext("2d");
        ctx.drawImage(
          canvas,
          0,
          position,
          canvas.width,
          pageContentHeight,
          0,
          0,
          canvas.width,
          pageContentHeight
        );

        const pageImgData = pageCanvas.toDataURL("image/png", 1.0);
        const pageImgHeight = (pageContentHeight * imgWidth) / canvas.width;

        if (position === 0) {
          pdf.addImage(
            pageImgData,
            "PNG",
            padding,
            padding,
            imgWidth,
            pageImgHeight
          );
        } else {
          pdf.addPage();
          pdf.addImage(
            pageImgData,
            "PNG",
            padding,
            padding,
            imgWidth,
            pageImgHeight
          );
        }

        position += pageContentHeight;
      }

      const timeStamp = new Date();
      const fileName = `${invoiceData?.order_number}_${timeStamp}.pdf`;
      //alert(fileName)
      const pdfBlob = pdf.output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl);
      // const link = document.createElement('a');
      // link.href = pdfUrl;
      // link.setAttribute(
      //   'download',
      //   fileName,
      // );

      // // Append to html link element page
      // document.body.appendChild(link);

      // // Start download
      // link.click();

      // // Clean up and remove the link
      // link.parentNode.removeChild(link);


    });
  };


  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    //
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Layout>
      <Header
        title="Manage Invoice"
        ItemActions={
          <Stack>
            <Button
              variant="outline-secondary"
              onClick={() => {
                navigate("/plan/billing");
              }}
            >
              Back
            </Button>
          </Stack>
        }
      />

      <Container fluid>
        {!isMobile ? <Card className="border px-0 p-0 m-0 "
          style={{
            backgroundColor: "#f8f9fa",
            borderRadius: "0px",
          }}>
          <div
            className="d-flex justify-content-between bg-white align-items-center p-2 flex-nowrap"
            style={{ overflowX: "auto", whiteSpace: "nowrap" }}
          >

            <div className="d-flex gap-2">
              <FormLabel className="mb-0 fw-semibold fs-6">
                # &nbsp;{invoiceData?.order_number}
              </FormLabel>
            </div>


            <div className="d-flex gap-2">
              <Button variant="outline-primary px-3 " onClick={handlePrint}>
                <UilImport className="mx-2" size="18" />
                Download PDF
              </Button>
              <Button
                variant={invoiceData?.grand_total === invoiceData?.paid_amount ? "primary " : "outline-primary"}
                disabled={invoiceData?.grand_total === invoiceData?.paid_amount}
                onClick={handlePayment}
              >
                {invoiceData?.grand_total === invoiceData?.paid_amount ? "Paid" : "Pay"}
              </Button>
            </div>
          </div>
          <Card
            className=""
            style={{
              borderRadius: "5px",
              backgroundColor: "#F2F2F2",
              height: "calc(100vh - 130px)",
              overflow: "auto",
              overflowX: "hidden",
            }}
          >
            <div className="d-flex justify-content-center py-3" >
              <div className=""
                style={{
                  width: "750px",
                  boxShadow:
                    " 0 1px 1px rgba(0,0,0,0.08), 0 2px 2px rgba(0,0,0,0.12), 0 4px 4px rgba(0,0,0,0.16), 0 8px 8px rgba(0,0,0,0.20)",
                }}
              >
                <DefaultInvoice item={invoiceData} componentRef={componentRef} />
              </div>
            </div>
          </Card>
        </Card> :
          <Card className="border p-0 m-0 "
            style={{
              //backgroundColor: "#f8f9fa",
              borderRadius: "0px",
            }}>
            <div className="p-2">
              <text className="mb-0 fw-semibold fs-4">
                Order Details
              </text>
            </div>
            <Card
              className="p-2"
              style={{
                borderRadius: "5px",
                //backgroundColor: "#F2F2F2",
                height: "calc(100vh - 130px)",
                overflow: "auto",
                overflowX: "hidden",
              }}
            >
              <div className="d-flex justify-content-center " >
                <div className=""
                  style={{
                    width: "750px",
                    // boxShadow:
                    //   " 0 1px 1px rgba(0,0,0,0.08), 0 2px 2px rgba(0,0,0,0.12), 0 4px 4px rgba(0,0,0,0.16), 0 8px 8px rgba(0,0,0,0.20)",
                  }}
                >
                  <MobileInvoice item={invoiceData}  />
                </div>
              </div>
            </Card>
          </Card>}

      </Container>
    </Layout>
  );
};

export default InvoiceLayout;
